<template>
  <div>
    <div style="text-align: end;">
      <a-button class="header-btn" @click="handleAdd">
        <a-icon type="plus"></a-icon>
        Añadir Fila
      </a-button>
      <a-button class="header-btn" type="primary" @click="send(1)">
        Grabar
      </a-button>
    </div>
    <a-table
      v-bind="tbConfig"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      rowKey="id"
      bordered>
      <div slot="filterDropdown"
           slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
           style="padding: 8px">
        <a-input v-ant-ref="c => searchInput = c"
                 :placeholder="`Buscar ${column.title}`"
                 :value="selectedKeys[0]"
                 @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                 @pressEnter="() => handleSearch(selectedKeys, confirm)"
                 style="width: 188px; margin-bottom: 8px; display: block;"/>
        <a-button type="primary"
                  @click="() => handleSearch(selectedKeys, confirm)"
                  icon="search"
                  size="small"
                  style="width: 90px; margin-right: 8px">
          Buscar
        </a-button>
        <a-button @click="() => handleReset(clearFilters)" size="small" style="width: 90px">
          Limpiar
        </a-button>
      </div>
      <a-icon
        slot="filterIcon"
        slot-scope="filtered"
        type="search"
        :style="{ color: filtered ? '#108ee9' : undefined }"
      />
      <span slot="debTitle">
        <a-tag color="red">
        Debito
      </a-tag>
      </span>
      <span slot="creTitle">
        <a-tag color="blue">
        Crédito
      </a-tag>
      </span>
      <template
        slot="id_third"
        slot-scope="text, record, index"
      >
        <form-model-dropdown style="width: 100%; margin: -5px 0"
                             v-model="record.id_third"
                             endpoint="third">
        </form-model-dropdown>
      </template>
      <template
        slot="comments"
        slot-scope="text, record, index"
      >
        <a-textarea autoSize
                    v-model="record.comments"/>
      </template>
      <template
        slot="id_chart_account"
        slot-scope="text, record, index"
      >
        <form-model-lookup style="width: 100%; margin: -5px 0"
                           v-model="record.id_chart_account"
                           placeholder="Cuenta"
                           endpoint="chart_account">
        </form-model-lookup>
      </template>
      <template
        slot="debito"
        slot-scope="text, record, index"
      >
        <a-input-number style="width: 100%" step="1"
                        v-model="record.ammount_l_deb"
                        @change="onDebito(record)"
                        :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\$\s?|(,*)/g, '')">
        </a-input-number>
      </template>
      <template
        slot="credito"
        slot-scope="text, record, index"
      >
        <a-input-number style="width: 100%" step="1"
                        v-model="record.ammount_l_cre"
                        @change="onCredito(record)"
                        :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\$\s?|(,*)/g, '')">
        </a-input-number>
      </template>
      <template slot="operation" slot-scope="text, record">
        <a href="javascript:;">
          <a-icon type="delete" theme="twoTone" two-tone-color="red" @click="customDelete(record.id)"/>
        </a>
      </template>
    </a-table>
    <invoices_totales :items="data"/>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import JsUtils from '@/util/JsUtils'

  const columns = [
    {
      key: 'cuenta',
      title: 'Cuenta',
      dataIndex: 'id_chart_account',
      scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon',
        customRender: 'id_chart_account'
      },
      onFilter: (value, record) =>
        record.cuenta
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
      onFilterDropdownVisibleChange: visible => {
        if (visible) {
          setTimeout(() => {
            this.searchInput.focus()
          }, 0)
        }
      }
    },
    {
      key: 'tercero',
      title: 'Tercero',
      dataIndex: 'id_third',
      scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon',
        customRender: 'id_third'
      },
      onFilter: (value, record) =>
        record.tercero
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
      onFilterDropdownVisibleChange: visible => {
        if (visible) {
          setTimeout(() => {
            this.searchInput.focus()
          }, 0)
        }
      }
    },
    {
      key: 'comentario',
      title: 'Comentario',
      dataIndex: 'comments',
      scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon',
        customRender: 'comments'
      },
      onFilter: (value, record) =>
        record.comments
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
      onFilterDropdownVisibleChange: visible => {
        if (visible) {
          setTimeout(() => {
            this.searchInput.focus()
          }, 0)
        }
      }
    },
    {
      key: 'debito',
      dataIndex: 'deb',
      slots: {title: 'debTitle'},
      scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon',
        customRender: 'debito'
      },
      onFilter: (value, record) =>
        record.ammount_l_deb
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
      onFilterDropdownVisibleChange: visible => {
        if (visible) {
          setTimeout(() => {
            this.searchInput.focus()
          }, 0)
        }
      }
    },
    {
      key: 'credito',
      dataIndex: 'cre',
      slots: {title: 'creTitle'},
      scopedSlots: {customRender: 'credito'},
      onFilter: (value, record) =>
        record.ammount_l_cre
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
      onFilterDropdownVisibleChange: visible => {
        if (visible) {
          setTimeout(() => {
            this.searchInput.focus()
          }, 0)
        }
      }
    },
    {
      key: 'acción',
      title: 'Acción',
      dataIndex: 'operation',
      scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon',
        customRender: 'operation'
      }
    }
  ]
  export default {
    props: ['id_invoice_line'],
    mounted () {
      this.httpClient = new HttpUtil()
      this.loadData()
    },
    data () {
      return {
        searchInput: null,
        searchText: '',
        loading: false,
        tbConfig: {
          scroll: {x: 'max-content'},
          bordered: true,
          size: 'small',
          pagination: {
            pageSize: 10,
            current: 1,
            showSizeChanger: true,
            pageSizeOptions: ['5', '10', '20', '30', '40'],
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
          }
        },
        count: -1,
        columns,
        data: []
      }
    },
    methods: {
      handleAdd () {
        const newData = {
          id: -1,
          id_invoice_line: this.id_invoice_line
        }
        this.send(newData)
      },
      customDelete (id) {
        this.$confirm({
          title: 'Confirmación',
          content: '¿Está seguro que desea eliminar el registro?',
          onOk: () => {
            return new Promise((resolve, reject) => {
              const dataSource = [...this.data]
              this.data = dataSource.filter(item => item.id !== id)
              if (id > 0) {
                this.httpClient.getInstance().delete('invoices_lines_ctb/' + id)
                  .then(() => {
                    Mensajes.success('Correcto', 'Se elimino correctamente')
                    resolve()
                  })
                  .catch((error) => {
                    Mensajes.error('Error', 'No fue posible eliminar el registro')
                    reject(error)
                  })
              } else {
                resolve()
              }
            })
          },
          onCancel () {
          }
        })
      },
      send (newData) {
        this.loading = true
        this.httpClient.getInstance().post('invoices_lines_ctb', {data: this.data})
          .then(() => {
            Mensajes.success('Correcto', 'Datos guardados correctamente')
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible guardar la información, contacte al administrador.')
          })
          .then(() => {
            if (newData !== 1) {
              this.loadDataSend(newData)
            } else {
              this.loadData()
            }
          })
      },
      setConfig () {
        this.tbConfig = {...this.tbConfig}
      },
      loadData () {
        this.loading = true
        this.httpClient.getInstance().post('invoices_lines_ctb' + '/datatable', {id_invoice_line: this.id_invoice_line})
          .then((response) => {
            const pagination = {...this.tbConfig.pagination}
            pagination.total = response.data.total
            this.loading = false
            this.data = response.data.data
            this.tbConfig.pagination = pagination
            this.setConfig()
          })
          .catch(() => {
            this.$notification['error']({
              message: 'Error.',
              description: 'No fue posible consultar la información.'
            })
            this.data = []
          })
          .then(() => {
            this.loading = false
          })
      },
      loadDataSend (newData) {
        this.httpClient.getInstance().post('invoices_lines_ctb' + '/datatable', {id_invoice_line: this.id_invoice_line})
          .then((response) => {
            const pagination = {...this.tbConfig.pagination}
            pagination.total = response.data.total
            this.loading = false
            this.data = response.data.data
            this.tbConfig.pagination = pagination
            this.setConfig()
          })
          .catch(() => {
            this.$notification['error']({
              message: 'Error.',
              description: 'No fue posible consultar la información.'
            })
            this.data = []
          })
          .then(() => {
            this.data = [...this.data, newData]
            this.loading = false
          })
      },
      onDebito (record) {
        if (!JsUtils.isEmpty(record.ammount_l_deb)) {
          record.ammount_l_cre = 0
        }
      },
      onCredito (record) {
        if (!JsUtils.isEmpty(record.ammount_l_cre)) {
          record.ammount_l_deb = 0
        }
      },
      handleSearch (selectedKeys, confirm, type = 'text') {
        confirm()
        if (type === 'text') {
          this.searchText = selectedKeys[0]
        }
      },
      handleReset (clearFilters) {
        clearFilters()
        this.searchText = ''
      }
    },
    watch: {
      id_invoice_line () {
        this.loadData()
      }
    }
  }
</script>
<style scoped>
  .header-btn {
    margin-right: 8px !important;
    margin-bottom: 12px !important;
  }
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Fmo/InvoicesLinesCtb.vue